export default "__VITE_ASSET__B3KYQ6kJ__"